import { useCallback } from 'react'
import { ProcessCellForExportParams, GridApi } from 'ag-grid-community'
import { exportExcel } from '../../../containers/BulkSheet/excel'
import { useDialogState } from '../../../components/dialogs/useDialogState'
import { getUserName, projectCellValueFormatter } from '../gridOptions'

export const useExcel = (gridApi: GridApi) => {
  const [dialogOpen, openDialog, closeDialog] = useDialogState()

  const customExportValues = useCallback(
    (params: ProcessCellForExportParams): string | undefined => {
      if (!params.node || params.node.rowIndex === null) return undefined
      const colId: string = params.column.getColId()
      if (colId === 'body.project') {
        return projectCellValueFormatter(params.value)
      }
      if (['body.user', 'body.project.projectManager'].includes(colId)) {
        return getUserName(params.value)
      }
      return undefined
    },
    []
  )

  const onExportExcel = useCallback(
    (colIds: string[]) => {
      if (!colIds || colIds.length === 0) return
      exportExcel({
        fileNamePrefix: 'resource_plan_cross_projects',
        gridApi,
        exportColIds: colIds,
        getCustomExportValue: customExportValues,
        shouldRowBeSkipped: params =>
          !params.node.data.body || !params.node.displayed,
      })
    },
    [gridApi, customExportValues]
  )

  return {
    dialogOpen,
    openDialog,
    closeDialog,
    onExportExcel,
  }
}
